module.exports = __webpack_public_path__ + "img/rmx.0355105c.png";